@if(resizeManager.isPortrait){
  <ion-header>
    <ion-toolbar>
      <ion-buttons slot="start">
        <ion-back-button (click)="back()" text="" ></ion-back-button>
      </ion-buttons>
      <ion-title>{{fileName}}</ion-title>
      <ion-buttons slot="end">
        <ion-button *ngIf="!isWeb" style="box-shadow: none" (click)="share()">
          <ion-icon name="fa-share"></ion-icon>
        </ion-button>
        <ion-button *ngIf="isWeb" style="box-shadow: none" title="Herunterladen" (click)="download()">
          <ion-icon name="fa-arrow-down"></ion-icon>
        </ion-button>
        <ion-button (click)="showOverView()" title="Übersicht anzeigen">
          <ion-icon name="fa-list"></ion-icon>
        </ion-button>
      </ion-buttons>
    </ion-toolbar>
  </ion-header>
}

<ion-content id="mainPdf" #mainPDF forceOverscroll="false" scrollY="false">

  <app-breadcrump-header [customOptions]="customBreadcrumbOptions"></app-breadcrump-header>

  <div id="overview" [ngClass]="{'open': isOverViewShow, 'close': isOverViewShow == false}" (clickOutside)="overviewOutsideClicked()">
    <div class="overview-item-wrapper" *ngFor="let pageNumber of pageOverViewArray" [ngStyle]="{'height.px' : pageNumber.pageHeight}" [class.activeOverViewItem]="page == pageNumber.pageNumber" (click)="page = pageNumber.pageNumber">
      <pdf-viewer
      [src]="pdfSrc" 
      [render-text]="false" 
      [show-all]="false" 
      [page]="pageNumber.pageNumber" 
      [original-size]="false" 
      (page-rendered)="overviewPageRendered($event, pageNumber)"
      [autoresize]="true"
      style="width: 100%; height: 100vh;">
      </pdf-viewer>
      <div class="overview-page-number">{{pageNumber.pageNumber}}</div>
    </div>
  </div>




  <div id="pages-count-container">
    <div id="pages-count">
      {{page}} / {{pageRendered}}
    </div>
  </div>
  <pinch-zoom [style.marginTop.px]="resizeManager.isPortrait ? 0 : 37" inch-zoom id="main-pdf" [wheel]="false" [double-tap]="false" disableZoomControl="disable">
    <pdf-viewer id="main-pdf" #pdfviewer [src]="pdfSrc"
                [zoom]="1"
                [show-all]="true"
                [(page)]="page"
                (after-load-complete)="afterPageRendered($event)"
                [render-text]="true"
                [render-text-mode]="1"
                [external-link-target]="'blank'"
                [original-size]="false" 
                style="width: 800px; height: 100%"
                ></pdf-viewer>
  </pinch-zoom> 
  
</ion-content>